var map = {
	"./gallery-wip-handle-disc_00.jpg": 2967,
	"./gallery-wip-handle-disc_01.jpg": 2968,
	"./gallery-wip-handle-disc_02.jpg": 2969,
	"./gallery-wip-handle-disc_03.jpg": 2970,
	"./gallery-wip-handle-disc_04.jpg": 2971,
	"./gallery-wip-handle-disc_05.jpg": 2972,
	"./gallery-wip-handle-disc_06.jpg": 2973,
	"./gallery-wip-handle-disc_07.jpg": 2974,
	"./gallery_00.jpg": 2975,
	"./gallery_01.jpg": 2976,
	"./gallery_02.jpg": 2977,
	"./gallery_03.jpg": 2978,
	"./gallery_04.jpg": 2979,
	"./gallery_05.jpg": 2980,
	"./gallery_06.jpg": 2981,
	"./gallery_07.jpg": 2982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2966;